var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { DropDownButton, ButtonGroup } from '@progress/kendo-vue-buttons';
import { ViewSelectorItem } from './ViewSelectorItem';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, dropdownlistSelectViewAriaLabel } from '../../../messages/main';
import { Icon } from '@progress/kendo-vue-common';
import { caretAltDownIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var ViewSelectorListVue2 = {
  name: 'KendoViewSelectorList',
  inject: {
    kendoLocalizationService: {
      default: null
    },
    ks: {
      default: null
    },
    setActiveViewName: {
      default: null
    }
  },
  mounted: function mounted() {
    this.calculateMedia();
    this.observer = new window.ResizeObserver(this.calculateMedia);
    this.observer.observe(this.$el);
  },
  destroyed: !!isV3 ? undefined : function () {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  // @ts-ignore
  unmounted: function unmounted() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  data: function data() {
    return {
      media: 'desktop'
    };
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this2 = this;
    var _this = this;
    var h = gh || createElement;
    var views = this.ks.views;
    this.localization = provideLocalizationService(this);
    var activeView = views.find(function (v) {
      return v.name === _this.ks.activeViewName;
    });
    var activeNameTitle = 'scheduler.' + activeView.name + 'ViewTitle';
    var activeName = this.localization.toLanguageString(activeNameTitle, messages[activeNameTitle]) || activeView.name;
    return h("div", {
      "class": "k-scheduler-views-wrapper"
    }, [activeView && this.media === 'mobile' &&
    // @ts-ignore  function children
    h(DropDownButton, {
      "class": "k-views-dropdown",
      "aria-label": this.localization.toLanguageString(dropdownlistSelectViewAriaLabel, messages[dropdownlistSelectViewAriaLabel]),
      attrs: this.v3 ? undefined : {
        "aria-label": this.localization.toLanguageString(dropdownlistSelectViewAriaLabel, messages[dropdownlistSelectViewAriaLabel]),
        tabIndex: -1,
        popupSettings: {
          popupClass: 'k-scheduler-toolbar'
        },
        textField: "title",
        items: views.map(function (v) {
          var nameTitle = 'scheduler.' + v.name + 'ViewTitle';
          var name = this.localization.toLanguageString(nameTitle, messages[nameTitle]) || v.name;
          return __assign(__assign({}, v.props), {
            selected: v.name === this.ks.activeViewName,
            name: v.name,
            title: v.title || name
          });
        }, this),
        text: activeView.title || activeName
      },
      tabIndex: -1,
      onItemclick: this.handleItemClick,
      on: this.v3 ? undefined : {
        "itemclick": this.handleItemClick
      },
      popupSettings: {
        popupClass: 'k-scheduler-toolbar'
      },
      textField: "title",
      items: views.map(function (v) {
        var nameTitle = 'scheduler.' + v.name + 'ViewTitle';
        var name = this.localization.toLanguageString(nameTitle, messages[nameTitle]) || v.name;
        return __assign(__assign({}, v.props), {
          selected: v.name === this.ks.activeViewName,
          name: v.name,
          title: v.title || name
        });
      }, this),
      text: activeView.title || activeName
    }, this.v3 ? function () {
      return [h(Icon, {
        name: "caret-alt-down",
        attrs: _this2.v3 ? undefined : {
          name: "caret-alt-down",
          icon: caretAltDownIcon
        },
        icon: caretAltDownIcon
      })];
    } : [h(Icon, {
      name: "caret-alt-down",
      attrs: _this2.v3 ? undefined : {
        name: "caret-alt-down",
        icon: caretAltDownIcon
      },
      icon: caretAltDownIcon
    })]), this.media === 'desktop' &&
    // @ts-ignore  function children
    h(ButtonGroup, {
      "class": "k-scheduler-views"
    }, this.v3 ? function () {
      return [views.map(function (view) {
        return h(ViewSelectorItem, {
          key: view.name,
          view: view,
          attrs: this.v3 ? undefined : {
            view: view
          }
        });
      }, _this2)];
    } : [views.map(function (view) {
      return h(ViewSelectorItem, {
        key: view.name,
        view: view,
        attrs: this.v3 ? undefined : {
          view: view
        }
      });
    }, _this2)])]);
  },
  methods: {
    handleItemClick: function handleItemClick(event) {
      event.event.preventDefault();
      if (event.item.name || event.item.title) {
        this.setActiveViewName(event.item.name || event.item.title);
      }
    },
    calculateMedia: function calculateMedia() {
      this.media = window.matchMedia('(min-width: 1024px)').matches ? 'desktop' : 'mobile';
    }
  }
};
/**
 * @hidden
 */
var ViewSelectorList = ViewSelectorListVue2;
export { ViewSelectorList, ViewSelectorListVue2 };